<template>
  <div>
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['info']" mode="horizontal">
        <a-menu-item key="info">
          <a-icon type="mail"/>
          订单信息
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px; top:8px">
        <a-button  type="primary" @click="onAdd">创建</a-button>
        <a-button @click="onCancel">返回</a-button>
      </a-space>
    </div>
    <div style="margin: 16px">
      <a-spin  :spinning="form.loading">
        <a-form-model ref="form" :model="form.data" :rules="form.rules">
          <a-row :gutter="24">
            <a-col :span="14">
              <a-card :bordered="false" title="基础信息">
                <a-button type="primary" @click="addGoods">添加商品</a-button>
                <div v-for="(item2,index) in goodsList" :key="index" class="addGoods">
                  <a-form-model-item label="选择商品" class="form-style" required >
                    <a-select v-model="item2.goodsId" placeholder="请选择商品" allowClear>
                      <a-select-option
                        v-for="item in goods.data"
                        :key="item.id"
                        :title="item.name"
                        :value="item.id"
                        @click="getSkuList(item.id)"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-icon type="plus-circle"  style="fontSize: 30px;margin:10px 0 0 20px" @click="addSkus(index)"></a-icon>
                  <div  v-for="(item1,index1) in item2.skuList"  :key="index1" class="addSku">
                    <a-form-model-item label="选择sku" class="form-style" required>
                      <a-select v-model="item1.skuId" placeholder="先选择商品在选择sku" allowClear>
                        <a-select-option
                          v-for="item in skus.data"
                          :key="item.id"
                          :title="item.specs"
                          :value="item.id"
                        >
                          {{ item.specs }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item  >
                    <a-form-model-item label="商品数量" class="form-style" required>
                      <a-input-number value="1" disabled></a-input-number>
                    </a-form-model-item   >
                    <a-icon type="minus-circle"  style="fontSize: 30px;margin:10px 0 10px 20px" @click="deleteRegex(index)"></a-icon>
                  </div>
                  <a-button type="primary" @click="deleteGoods(index)" style="margin: 10px 0px 10px 20px">删除商品</a-button>
                </div>
              </a-card>
              <a-card :bordered="false" style="margin-top: 20px" title="用户信息" >
                <a-form-model-item label="选择用户" required>
                  <a-select v-model="form.data.userId" placeholder="请选择">
                    <a-select-option
                      v-for="item in user.data"
                      :key="item.id"
                      :title="item.firstName"
                      :value="item.id"
                    >
                      {{ item.firstName }} {{ item.lastName }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-card>
              <a-card :bordered="false" style="margin-top: 20px" title="支付信息" >
                <a-form-model-item label="选择支付方式" required>
                  <dict-select
                    v-model="form.data.payment"
                    dict-code="PAY_PAYMENT"/>
                </a-form-model-item>
                <a-form-model-item label="选择国家/地区" required>
                  <a-select v-model="form.data.location" placeholder="请选择">
                    <a-select-option
                      v-for="item in location.data"
                      :key="item.id"
                      :title="item.code"
                      :value="item.code"
                    >
                      {{ item.code }} / {{ item.currencyCode}} / {{ item.unit}}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-card>
            </a-col>
            <a-col :span="10">
              <a-card :bordered="false" title="地址信息">
                <a-form-model-item label="First name" required>
                  <a-input v-model="form.data.firstName"/>
                </a-form-model-item>
                <a-form-model-item label="Last name" required>
                  <a-input v-model="form.data.lastName"/>
                </a-form-model-item>
                <a-form-model-item label="Country/Region" required>
                  <a-input v-model="form.data.country"/>
                </a-form-model-item>
                <a-form-model-item label="Town/City" required>
                  <a-input v-model="form.data.town"/>
                </a-form-model-item>
                <a-form-model-item label="Street/Address" required>
                  <a-input v-model="form.data.street"/>
                </a-form-model-item>
                <a-form-model-item label="Postcode" required>
                  <a-input v-model="form.data.postCode"/>
                </a-form-model-item>
                <a-form-model-item label="Phone prefix" required>
                  <a-input v-model="form.data.phonePrefix"/>
                </a-form-model-item>
                <a-form-model-item label="Phone number" required>
                  <a-input v-model="form.data.phone"/>
                </a-form-model-item>
                <a-form-model-item label="Email" required>
                  <a-input v-model="form.data.email"/>
                </a-form-model-item>
              </a-card>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </div>       <!-- </a-card> -->
  </div>
</template>

<script>
import {
  _queryOrder,
  _addOrder,
  _updateOrder,
  _queryLocation,
} from '@/api/websiteOrderApi';
import {
  _queryCustomizeGoods,
} from '@/api/websiteGoodsApi';
import {
  _queryGoodsSkus,
} from '@/api/websiteGoodsSkuApi';
import {
  _queryUsers,
} from '@/api/websiteUserApi';
import moment from 'moment';
import DictSelect from '../../../components/DictSelect.vue';

async function onAdd() {
  const res = []
  this.goodsList.forEach(item => {
    res.push(...item.skuList)
  })
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addOrder({
        firstName: this.form.data.firstName,
        lastName: this.form.data.lastName,
        country: this.form.data.country,
        town: this.form.data.town,
        street: this.form.data.street,
        phone: this.form.data.phone,
        email: this.form.data.email,
        phonePrefix: this.form.data.phonePrefix,
        postCode: this.form.data.postCode,
        location: this.form.data.location,
        channel: this.form.data.channel,
        skuQualities: res,
        userId: this.form.data.userId,
        payment: this.form.data.payment,
      });
      if (result) {
        this.$message.success('添加成功');
      }
    }
  });
}
//
// async function onUpdate() {
//   this.$refs.form.validate(async (valid) => {
//     if (valid) {
//       await _updateOrder(this.orderId, {
//         name: this.form.data.name,
//         nameEn: this.form.data.nameEn,
//         code: this.form.data.code,
//         seriesId: this.form.data.seriesId,
//         categoryId: this.form.data.categoryId,
//         isLimited: this.form.data.isLimited,
//         limitedQuantity: this.form.data.limitedQuantity,
//         status: this.form.data.status,
//         isPresell: this.form.data.isPresell,
//         sellStartAt: this.form.data.sellStartAt,
//         sellEndAt: this.form.data.sellEndAt,
//         price: this.form.data.price,
//         listPrice: this.form.data.listPrice,
//         coverPath: this.form.data.coverPath,
//         description: this.form.data.description,
//         descriptionEn: this.form.data.descriptionEn,
//         salesQuantity: this.form.data.salesQuantity,
//         images: this.form.data.images.join('|'),
//         type: this.form.data.type,
//         inspirationImg: this.form.data.inspirationImg.join('|'),
//         inspirationVideo: this.form.data.inspirationVideo.join('|'),
//         previousPrice: this.form.data.previousPrice,
//         content: this.form.data.content,
//         isVip: this.form.data.isVip,
//         sizeImage: this.form.data.sizeImage,
//         videoCover: this.form.data.videoCover,
//         vipCategoryId: this.vipCategoryId,
//         vipSeriesId: this.vipSeriesId,
//         isNew: this.form.data.isNew,
//         startPrice: this.form.data.startPrice,
//         endPrice: this.form.data.endPrice,
//         dollarPrice: this.form.data.dollarPrice,
//         channel: this.form.data.channel,
//         material: this.form.data.material,
//       });
//
//       this.$message.success('更新成功');
//       this.getGoods();
//     }
//   });
// }
//

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  } else {
    this.$router.go(-1);
  }
}

async function getSkuList(id) {
  // 查询skus
  const result = await _queryGoodsSkus(id, {});
  this.skus.data = result;
}

function addSkus(index) {
  this.goodsList[index].skuList.push({ skuId: '' })
}

function addGoods() {
  this.goodsList.push({ goodsId: '', skuList: [{ skuId: '' }] });
}

export default {
  name: 'OrderCreate',
  components: {
    DictSelect,
    // OrderExpressList,
    // OrderCard,
    // OrderEdit,
  },
  props: {
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  data() {
    return {
      goodsList: [
        {
          goodsId: '',
          skuList: [
            {
              skuId: '',
            }
          ],
        },
      ],
      goods: {
        data: [],
      },
      skus: {
        data: [],
      },
      user: {
        data: [],
      },
      location: {
        data: [],
      },
      form: {
        loading: false,
        data: {
          payment: '',
          id: '',
          name: '',
          code: '',
          firstName: '',
          lastName: '',
          country: '',
          town: '',
          street: '',
          postCode: '',
          phonePrefix: '',
          phone: '',
          email: '',
          location: '',
          channel: 'cms',
          goodsId: '',
          skuId: '',
          skuQualities: [
            {
              skuId: '',
            }
          ],
        },
      },
    };
  },
  methods: {
    moment,
    onAdd,
    // onUpdate,
    onCancel,
    getSkuList,
    addSkus,
    addGoods,
    deleteRegex(index) {
      if (this.form.data.skuQualities.length > 1) {
        this.form.data.skuQualities.splice(index, 1);
      } else {
        this.$message.warning('至少保留一组数据');
      }
    },
    deleteGoods(index) {
      if (this.goodsList.length > 1) {
        this.goodsList.splice(index, 1);
      } else {
        this.$message.warning('至少保留一组数据');
      }
    }
  },
  async created() {
    const goodsResult = await _queryCustomizeGoods();
    this.goods.data = goodsResult;
    const result = await _queryUsers({});
    this.user.data = result.content;
    const locationResult = await _queryLocation();
    this.location.data = locationResult;
  },
};
</script>

<style scoped>
.addSku {
  margin: 20px 20px 0 20px;
  border:1px solid black;
  /*width: 400px;*/
  width: auto;
}
.addGoods {
  margin-top: 25px;
  border:1px solid black;
}
.form-style {
  margin: 0 20px;
  /*width: 350px;*/
  width: auto;
}
</style>
